import { adminCall } from '../../../api/adminCall';

export async function setControlPanelName(name) {
  const data = await adminCall('/api/admin/platform/control-panel', { name });
  if (!data?.success && !data?.name) {
    throw new Error(data?.error || 'Failed to save control panel name');
  }
  return data;
}
